// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--8a997";
export var bannerBg = "styles-module--bannerBg--cbff1";
export var bannerInner = "styles-module--bannerInner--63f71";